import React, { FC } from 'react';
import collaborateImage from './collaborate.png';
import connectImage from './connect.png';

interface SessionInfo {
    unifiedPlatform: boolean;
}

const SessionInfo: FC<SessionInfo> = ({ unifiedPlatform }) => (
    <div className="control-center__session-info">
        {unifiedPlatform ? <img src={collaborateImage} alt="Collaborate" /> : <img src={connectImage} alt="Connect" />}
        {unifiedPlatform ? (
            <div>
                <p>
                    <strong>Go to Apps & Integrations under Egnyte Collaborate</strong>
                </p>
                <p>to see App Control Center with full capabilities.</p>
            </div>
        ) : (
            <div>
                <p>
                    <strong>Go to Apps & Integrations under Egnyte Connect</strong>
                </p>
                <p>to see App Control Center with full capabilities.</p>
            </div>
        )}
    </div>
);

export default SessionInfo;
